// DS2.5.1
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import NotificationCounter from '../../Indicators/NotificationCounter';
import IconButton from '../IconButton';
import shortenNumber from '../../../utils/shortenNumber';
import s from './IconButtonWithNotification.scss';
export function limitNumber(number) {
    return number > 999 ? shortenNumber(number, 0, Math.floor) : `${number}`;
}
const IconButtonWithNotification = (_param)=>{
    var { className, iconButtonClassName, numberClassName, count, notificationColor } = _param, iconButtonProps = _object_without_properties(_param, [
        "className",
        "iconButtonClassName",
        "numberClassName",
        "count",
        "notificationColor"
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['icon-button-wrapper'], className)
    }, /*#__PURE__*/ React.createElement(IconButton, _object_spread_props(_object_spread({}, iconButtonProps), {
        className: c(s['root'], iconButtonClassName)
    })), !!count && /*#__PURE__*/ React.createElement(NotificationCounter, {
        className: c(s['number'], numberClassName),
        color: notificationColor
    }, limitNumber(count)));
};
IconButtonWithNotification.displayName = 'IconButtonWithNotification';
export default IconButtonWithNotification;

//# sourceMappingURL=IconButtonWithNotification.js.map